import { element } from "prop-types";
import { lazy } from "react";

const Gym = lazy(() => import("@views/Order/Gym"))
const Sports = lazy(() => import("@views/Order/Sports"))
const Hospital = lazy(() => import("@views/Order/Hospital"))
const Library = lazy(() => import("@views/Order/Library"))
const Book = lazy(() => import("@views/Order/Book"))

const EBookDetails = lazy(() => import("@views/Order/Book/LibraryCatalog/Ebook/BookDetail"))

const OrderRoutes = [
    {
        path: 'service/order/sports/',
        element: <Sports/>
    },
    {
        path: 'service/order/gym/',
        element: <Gym/>
    },
    {
        path: 'service/order/hospital/',
        element: <Hospital/>
    },
    {
        path: 'service/order/library/',
        element: <Library/>
    },
    {
        path: 'service/order/book/',
        element: <Book/>
    },
    {
        path: 'service/order/book/library/ebook/bookdetail/:ebookId',
        element: <EBookDetails/>
    }
]
export default OrderRoutes
